import { CURRENT_API_VERSION } from '@config/api';
import { HTTP_METHOD } from '@config/net';

import { authedHttpFetch } from '@services/base/authed-http-fetch';
import { jsonOwnHeaders } from '@services/base/json-fetch';
import { ServiceAuthData } from '@types';

import {
  AuthedJsonFetchConfig,
  AuthedJsonFetchHeaders,
  AuthedJsonFetchOwnHeaders,
  AuthedJsonFetchResult,
} from './types';

const authedJsonOwnHeaders = jsonOwnHeaders;

export const authedJsonFetch = <
  R,
  D = undefined,
  P = undefined,
  H extends AuthedJsonFetchHeaders = undefined
>(
  url: string,
  authData: ServiceAuthData,
  config?: AuthedJsonFetchConfig<D, P, H>
): AuthedJsonFetchResult<R> => {
  const isGetRequest = config?.method === HTTP_METHOD.GET;

  const nextConfig = {
    ...config,
    params: isGetRequest
      ? {
          ...(config?.params as P),
          'api-version': CURRENT_API_VERSION,
        }
      : config?.params,
    data: !isGetRequest
      ? {
          ...(config?.data as D),
          'api-version': CURRENT_API_VERSION,
        }
      : config?.data,
    headers: {
      ...authedJsonOwnHeaders,
      ...config?.headers,
    },
  };

  const { promise, cancel } = authedHttpFetch<
    R,
    D,
    P,
    AuthedJsonFetchOwnHeaders | (AuthedJsonFetchOwnHeaders & H)
  >(url, authData, nextConfig);

  return {
    promise: promise.then(({ data }) => data),
    cancel,
  };
};
